import React from 'react';
import Soon from './Soon';
import NavBar from './LandingComponents/Navbar';

function Works() {
  return (
    <>
      <NavBar />
      <Soon />
    </>
  );
}

export default Works;
